import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class SubscriberService {

  // Cambiar API
  constructor(private http: HttpClient) { }

  getSubscribers(idSpace: string, page: number, searchText: string, sorted: any) {
    let url = `${AppSettings.API_URI_V2}/spaces/${idSpace}/subscribers?page=${page}`;
    if (searchText) {
      url += `&search=${searchText}`;
    }
    if (sorted) {
      url += `&orderBy=${sorted.sortedBy}&order=${sorted.sort}`;
    }
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getCountSubscribers(idSpace: string) {
    let url = `${AppSettings.API_URI_V2}/spaces/${idSpace}/subscribers/count`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  editSubscription(userId: number, spaceId: number,data: any) {
    let url = `${AppSettings.API_URI_V2}/spaces/${spaceId}/subscription/${userId}`;
    return this.http.put<any>(url, data).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  subscriberFromUser(idSpace: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/spaces/${idSpace}/subscribe`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

}
